<div class="dialog-wrapper">
  <div class="head">
    <label class="typo body-1 fw400 semi-condensed">Manage Profile Information</label>
  </div>
  <div class="body">
    <mat-tab-group disableRipple="true" class="custom-mat-tab-group">
      <!-- Option Profile -->
      <mat-tab class="custom-mat-tab">
        <ng-template mat-tab-label>
          <mat-icon svgIcon="ico-profile" class="custom-mat-icon ico-size ico-1xs"></mat-icon>
          Profile
        </ng-template>
        <div *ngIf="formIsLoaded" class="body-container">
          <form [formGroup]="formProfile" novalidate class="form-wrapper">
            <div class="form-section">
              <div class="form-section-body">
                <mat-card class="custom-mat-card card-form-wrapper">
                  <mat-card-content class="custom-mat-card-content">
                    <div class="card-section">
                      <div class="card-row">
                        <mat-form-field class="size size1of2">
                          <input matInput required placeholder="First name" formControlName="firstname">
                        </mat-form-field>
                        <mat-form-field class="size size1of2">
                          <input matInput required placeholder="Last name" formControlName="lastname">
                        </mat-form-field>
                      </div>
                      <div class="card-row">
                        <mat-form-field class="size size1of1">
                          <input matInput placeholder="Email" formControlName="username">
                        </mat-form-field>
                      </div>
                      <div class="card-row">
                        <mat-form-field class="custom-mat-form-field size size1of1" floatLabel="always">
                          <!-- <span matPrefix>+1 &nbsp;</span> -->
                          <mat-label>Phone (Optional)</mat-label>
                          <input matInput placeholder="404 222 3333" formControlName="phoneNum">
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </form>
          <nav class="post-form">
            <button mat-flat-button (click)="updateProfile()" color="primary" class="custom-mat-button-primary rounded typo uppercase" [disabled]="formSubmitted">Save Profile</button>
          </nav>
        </div>
      </mat-tab>
      <!-- Option Password -->
      <mat-tab class="custom-mat-tab">
        <ng-template mat-tab-label>
          <mat-icon svgIcon="ico-password" class="custom-mat-icon ico-size ico-1xs"></mat-icon>
          Password
        </ng-template>
        <div class="body-container">
          <div class="form-wrapper">
            <div class="form-section">
              <div class="form-section-body">
                <mat-card class="custom-mat-card card-form-wrapper">
                  <mat-card-content class="custom-mat-card-content">
                    <div class="card-section">
                      <div class="card-row">
                        <mat-form-field class="size size1of1">
                          <input matInput placeholder="New Password">
                        </mat-form-field>
                      </div>
                      <div class="card-row">
                        <mat-form-field class="size size1of1">
                          <input matInput placeholder="Confirm New Password">
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </div>
        <nav class="post-form">
          <button mat-flat-button color="primary" class="custom-mat-button-primary rounded typo uppercase">Change Password</button>
        </nav>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>